import create from 'zustand';

import User from 'Models/User';

const [useUserStore] = create((set) => ({
	currentUser: null,
	setUser: (user) => set({ currentUser: user }),
	login: async (params) => {
		const response = await User.login(params);

		if (response.error) {
			response.user = null;
			return response;
		}

		if (response.jwt) {
			localStorage.setItem('token', response.jwt);
		}

		set({ currentUser: response.user });
		return response.user;
	},
	fetchUser: async () => {
		if (localStorage.getItem('token')) {
			const response = await User.get();
			set({ currentUser: response });
		}
	},
	syncEtsy: async (params) => {
		console.log('call etsy');
		const response = await User.syncEtsy(params);

		if (response.loginUrl) {
			window.location.href = response.loginUrl;
		}
	}
}));

export default useUserStore;
